




















































































































import {Component, Vue} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import moment from 'moment';
import {viewEditingStateModule} from '@/store/state/viewEditingState';
import {progress} from '@/script/progress';
import {入札商品型, 入札型} from '@/type/estimates/bid';
import {遡及検索条件型, 遡及訂正登録依頼型} from '@/type/retrospective/retrospective';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import UsageClassSelector from '@/components/item/UsageClassSelector.vue';
import 価格登録遡及訂正入力チェッカー from '@/type/retrospective/価格登録遡及訂正入力チェッカー';


@Component({
  components: {
    Datepicker,
    NormalDialog,
    ButtonPanel,
    IconButton,
    NormalButton,
    ConfirmDialog,
    AlertDialog,
    UsageClassSelector,
  },
})
export default class Retrospective extends Vue {
  private 最新入札: 入札型 | null = null;
  private 入札一覧: 入札商品型[] = [];
  private 検索依頼: 遡及検索条件型 | null = null;
  private 遡及訂正登録依頼: 遡及訂正登録依頼型 | null = null;
  private 有効適用開始日From: Date = moment().toDate();
  private アラートメッセージ: string | string[] | null = null;
  private registerModal: boolean = false;

  private 適用終了日の指定範囲を取得する() {
    return {
      from: moment().startOf('day').add(1, 'days').toDate(),
    };
  }

  private async created() {
    this.initialize();
    this.clear();
  }

  private async initialize(): Promise<void> {
    await this.latest();
    viewEditingStateModule.初期化する();
  }

  private async latest() {
    this.最新入札 = await api.最新の入札を取得する();
  }

  private async bid() {
    await api.入札を取込する()
      .then((response: any) => {
        this.入札一覧 = response.入札一覧;
        this.検索依頼 = {
          ソート区分: '商品名カナ',
          使用区分: null,
          商品区分: null,
          適用開始日: response.適用開始日,
          入札開始日: response.入札開始日,
          作成番号: response.作成番号,
        };
        this.遡及訂正登録依頼 = {
          適用開始日: this.検索依頼.適用開始日,
          入札開始日: this.検索依頼.入札開始日,
          作成番号: this.検索依頼.作成番号,
          商品区分: this.検索依頼.商品区分,
          使用区分: this.検索依頼.使用区分,
          適用終了日: null,
        };
        this.closeDialog('取込ダイアログ');
        if (this.入札一覧.length === 0) {
          this.アラートメッセージ = '該当の入札は存在しません';
          this.openDialog('アラート');
          return;
        }
      });
  }

  private async bidHandler(): Promise<void> {
    viewEditingStateModule.画面の編集を開始する();
    await progress(this.bid);
  }

  private async search() {
    if (this.検索依頼 == null) {
      return;
    }
    this.遡及訂正登録依頼 = {
      適用開始日: this.検索依頼.適用開始日,
      入札開始日: this.検索依頼.入札開始日,
      作成番号: this.検索依頼.作成番号,
      商品区分: this.検索依頼.商品区分,
      使用区分: this.検索依頼.使用区分,
      適用終了日: null,
    };
    this.入札一覧 = [];
    await api.遡及を検索する(this.検索依頼)
      .then((response: any) => {
        this.入札一覧 = response.遡及検索結果レコード;
        if (this.入札一覧.length === 0) {
          this.アラートメッセージ = '該当の入札は存在しません';
          this.openDialog('アラート');
          return;
        }
        if (response.アラートメッセージ) {
          this.アラートメッセージ = response.アラートメッセージ;
          this.openDialog('アラート');
        }
      })
      .catch((error: any) => {
        this.アラートメッセージ = error.data.message;
        this.openDialog('アラート');
      });
  }

  private async searchHandler(): Promise<void> {
    await progress(this.search);
  }

  private async register() {
    if (this.遡及訂正登録依頼 == null) {
      return;
    }
    const checker = new 価格登録遡及訂正入力チェッカー(this.遡及訂正登録依頼);
    if (checker.hasErrors()) {
      this.アラートメッセージ = checker.errorMessages();
      this.openDialog('アラート');
      return;
    }
    await api.遡及訂正登録する(this.遡及訂正登録依頼)
      .then((response: any) => {
        this.closeDialog('訂正登録ダイアログ');
        this.clear();
      })
      .catch((error: any) => {
        if (!error.data.errors) {
          this.アラートメッセージ = error.data.message;
        }
        if (error.data.errors) {
          this.アラートメッセージ = error.data.errors;
        }
        this.openDialog('アラート');
      });
  }

  private async registerHandler(): Promise<void> {
    await progress(this.register);
  }

  private openDialog(name: string): void {
    this.$modal.show(name);
  }

  private closeDialog(name: string): void {
    this.$modal.hide(name);
  }

  private clear() {
    this.検索依頼 = {
      ソート区分: '商品名カナ',
      使用区分: null,
      商品区分: null,
      適用開始日: null,
      入札開始日: null,
      作成番号: null,
    };
    this.入札一覧 = [];
    this.closeDialog('クリアダイアログ');
    viewEditingStateModule.画面の編集を終了する();
  }

  private get canBid() {
    if (this.最新入札 == null) {
      return false;
    }
    return this.最新入札.入札確定フラグ === '確定' && this.最新入札.入札開始日 != null;
  }

  private get canSearch() {
    if (this.検索依頼 == null) {
      return false;
    }
    return this.検索依頼.適用開始日 != null;
  }
}
